import React from "react";
import "./RadioSelect.css";

const RadioSelect = ({ type, id, name, label, checked, onChange }) => {
    return (
        <>
            <input
                type={type}
                id={id}
                value={id}
                name={name}
                aria-label={label}
                // aria-checked={checked}
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor={id}>{label}</label>
        </>
    )}

export default RadioSelect;